export default __webpack_public_path__ + "static/media/sign.42b230df.png";